var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
  stroke: "#A8AAAC",
  strokeWidth: 2
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 5,
  width: 2,
  height: 10,
  rx: 1,
  fill: "#A8AAAC"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 9,
  width: 2,
  height: 10,
  rx: 1,
  transform: "rotate(90 15 9)",
  fill: "#A8AAAC"
})));
export default SvgIconAdd;